
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productFile/create",
      function () {
        return require("private-next-pages/productFile/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productFile/create"])
      });
    }
  